import React, { useState, useEffect, useRef } from 'react'
import { Modal } from 'antd'
import { SERVICE_TITLE } from 'service'
import styles from './style.module.scss'

const IMPORT_SOURCES = [
  { key: 'safepassword', label: `${SERVICE_TITLE} (.json, .json.enc)`, accept: '.json,.enc' },
  { key: 'google', label: 'Google Password Manager (.csv)', accept: '.csv' },
]

const ImportSourceModal = ({ visible, onSelect, onCancel, t }) => {
  const [selected, setSelected] = useState(IMPORT_SOURCES[0].key)
  const listRef = useRef(null)

  useEffect(() => {
    if (visible) {
      setSelected(IMPORT_SOURCES[0].key)
      // 모달 열릴 때 첫 번째 항목에 focus → 키보드 방향키 즉시 동작
      setTimeout(() => {
        listRef.current?.querySelector('[tabindex="0"]')?.focus()
      }, 100)
    }
  }, [visible])

  const handleNext = () => {
    const source = IMPORT_SOURCES.find((s) => s.key === selected)
    if (source) onSelect(source)
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      closable={false}
      width={480}
      destroyOnClose
      className={styles.importSourceModal}
    >
      <div className={styles.importSourceContent}>
        <div className={styles.importSourceHeader}>
          <span className={styles.importSourceTitle}>
            {t('record.import.selectSourceTitle')}
          </span>
        </div>
        <div className={styles.importSourceContainer}>
          <p className={styles.importSourceDescription}>
            {t('record.import.selectSourceDescription')}
          </p>
          <div className={styles.importSourceList} ref={listRef}>
            {IMPORT_SOURCES.map((source) => (
              <div
                key={source.key}
                className={`${styles.importSourceItem} ${selected === source.key ? styles.importSourceItemSelected : ''}`}
                onClick={() => setSelected(source.key)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') setSelected(source.key)
                  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    e.preventDefault()
                    const idx = IMPORT_SOURCES.findIndex((s) => s.key === source.key)
                    const nextIdx = e.key === 'ArrowDown'
                      ? Math.min(idx + 1, IMPORT_SOURCES.length - 1)
                      : Math.max(idx - 1, 0)
                    setSelected(IMPORT_SOURCES[nextIdx].key)
                    e.currentTarget.parentElement.children[nextIdx]?.focus()
                  }
                }}
              >
                {source.label}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.importSourceFooter}>
        <div className={styles.importSourceSpacer} />
        <button
          type="button"
          className={styles.importSourceBtnCancel}
          onClick={onCancel}
        >
          {t('common.button.cancel')}
        </button>
        <button
          type="button"
          className={styles.importSourceBtnNext}
          onClick={handleNext}
        >
          {t('record.import.next')}
        </button>
      </div>
    </Modal>
  )
}

export default ImportSourceModal
